import React, { useState } from "react";
import { createTravelPartner } from "../../api/TravelPartner";
import Swal from "sweetalert2";

const CreateTravelPartner = ({ onSuccess }) => {
  const [companyName, setCompanyName] = useState("");
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!companyName.trim()) {
      Swal.fire("Error", "Company name is required", "error");
      return;
    }

    if (!image) {
      Swal.fire("Error", "Image is required", "error");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("company_name", companyName);
      formData.append("image", image);

      const response = await createTravelPartner(formData);

      if (response) {
        Swal.fire("Success", "Travel partner created successfully", "success");
        setCompanyName("");
        setImage(null);
        // Reset file input
        document.getElementById("exampleInputImage").value = "";
        if (onSuccess) {
          onSuccess(response);
        }
      }
    } catch (error) {
      console.error("Error creating travel partner:", error);
      Swal.fire("Error", "Failed to create travel partner", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form className="text-left" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="exampleInputComapanyName">Company Name</label>
          <input
            type="text"
            className="form-control"
            id="exampleInputComapanyName"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            placeholder="Enter company name"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputImage">Image</label>
          <input
            type="file"
            className="form-control"
            id="exampleInputImage"
            accept="image/*"
            onChange={handleImageChange}
            required
          />
        </div>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </form>
    </>
  );
};

export default CreateTravelPartner;
